module.exports = "<igo-print igoPrintBinding></igo-print>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/print-tool/print-tool.component.html
// module id = 1149
// module chunks = 0